import React, { createContext, useCallback, useContext, useState } from "react";

const SS_KEY = "customer_cart_context";

const readFromStorage = () => {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const CustomerCartContext = createContext(null);

export const CustomerCartProvider = ({ children }) => {
  const [customer, setCustomerState] = useState(readFromStorage);

  const setCustomer = useCallback((nextCustomer) => {
    if (nextCustomer) {
      sessionStorage.setItem(SS_KEY, JSON.stringify(nextCustomer));
    } else {
      sessionStorage.removeItem(SS_KEY);
    }
    setCustomerState(nextCustomer);
  }, []);

  return (
    <CustomerCartContext.Provider value={{ customer, setCustomer }}>
      {children}
    </CustomerCartContext.Provider>
  );
};

export const useCustomerCart = () => useContext(CustomerCartContext);
